import { Page, Shop } from '../../../../types'
import { HttpClientConfig } from '../../../useHttpClientConfig'
import { apiVersion, service } from '../service'
import { FilterValue, applySearchParams, responseToPage, urlToPathnameAndSearch } from '../utils'

type ShopsFilter = 'gid' | 'id' | 'page_size'
type ShopsFilters = Partial<Record<ShopsFilter, FilterValue>>

const pathname = `/api/${apiVersion}/shops`

const makeGetShops =
  (baseUrl: string, config: HttpClientConfig) =>
  async (filters: ShopsFilters): Promise<Page<Shop>> => {
    const url = new URL(pathname, baseUrl)

    applySearchParams(url, filters)

    const pathnameAndSearch = urlToPathnameAndSearch(url)

    const response = await service(baseUrl).get(pathnameAndSearch, config)

    return responseToPage<Shop>(response)
  }

export { makeGetShops }
export type { ShopsFilters }
